import { useEffect, useState } from 'react';
import { LoginApi } from '@apply/api/src/api/loginApi';
import { applicationInsights } from '../../ApplicationInsights';

export const useIpAddress = (): string => {
    const [ipAddress, setIpAddress] = useState<string>('');

    useEffect(() => {
        const api = new LoginApi(applicationInsights);
        api.getIpAddress().then((response) => {
            if (response.statusCode === 200) {
                setIpAddress(response.result);
            }
        });
    }, []);

    return ipAddress;
};
